import { Need } from './need';

export class PatientNeed extends Need {
  memberid: string;
  identifiedby: string = null;
  identifieddate: Date;
  source: NeedSource;
  diagcode: string;
  orgid: number;
  orglevel: number;
  sourcedescription = '';
  careplanid: number;
  modifieddttm: Date;
  modifiedby: string;
  addedby: string;
  addeddt: Date;
  generatedby: string;
  activitynotes: string;
}

export enum NeedSource {
  ASSESSMENT = 'ASSESSMENT',
  VISIT = 'VISIT',
  DIAGNOSIS = 'DIAGNOSIS',
  OTHER = 'OTHER'
}
